
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'


export default {
name: 'MyFooter',
components: {
Tabbar,
TabbarItem
},
data () {
return {
buttonTitle: this.MyGlobal.title
}
},
methods: {
clickTitle () {
console.log('--do me--')
}
}
}



// WEBPACK FOOTER //
// ./src/components/common/myFooter.vue